import * as types from '../actions/mainMenu/types';


const INITIAL_STATE = {
  open: false,
};

export default function mainMenuReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.CLOSE_MAIN_MENU:
      return {
        ...state,
        open: false,
      };

    case types.OPEN_MAIN_MENU:
      return {
        ...state,
        open: true,
      };

    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/mainMenuReducer.js